import { extendObservable, action } from 'mobx'
import get from 'lodash/get'

export default async (state, initialState) => {
  const activeApps = get(initialState, '_activeApps', {})
  
  extendObservable(state, {
    _activeApps: activeApps
  })
  
  return {}
}
